/* import __COLOCATED_TEMPLATE__ from './fast-edit.hbs'; */
import templateOnlyComponent from '@ember/component/template-only';
import TEMPLATE from "./fast-edit.hbs";
import { setComponentTemplate } from "@ember/component";
export default setComponentTemplate(TEMPLATE, templateOnlyComponent());